export const ROUTE_NAMES = {
  LIST: 'deb-collection-list',
  DETAILS: 'deb-collection-details',
  FLOW_LIST: 'deb-collection-flow-list',
  FLOW_DETAILS: 'deb-collection-flow-details'
}

const ROUTES = {
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'debtcollection/list'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: 'debtcollection/case/:id'
  },
  [ROUTE_NAMES.FLOW_LIST]: {
    name: ROUTE_NAMES.FLOW_LIST,
    path: 'debtcollection/flow/list'
  },
  [ROUTE_NAMES.FLOW_DETAILS]: {
    name: ROUTE_NAMES.FLOW_DETAILS,
    path: 'debtcollection/flow/:cc'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LIST].name,
    path: ROUTES[ROUTE_NAMES.LIST].path,
    component: (resolve) => require(['./views/list'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.DETAILS].name,
    path: ROUTES[ROUTE_NAMES.DETAILS].path,
    component: (resolve) => require(['./views/details'], resolve),
    props: true
  },
  {
    name: ROUTES[ROUTE_NAMES.FLOW_LIST].name,
    path: ROUTES[ROUTE_NAMES.FLOW_LIST].path,
    component: (resolve) => require(['./views/flow/list'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.FLOW_DETAILS].name,
    path: ROUTES[ROUTE_NAMES.FLOW_DETAILS].path,
    component: (resolve) => require(['./views/flow/details'], resolve),
    props: true
  }
]
